import React from 'react'
import { history } from '../store'

class ModuleList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPopup: false,
      popupPosition: { x: 0, y: 0 },
      selectedCode: null,
    }
    this.hidePopup = this.hidePopup.bind(this)
  }

  goTo(Code) {
    history.push(`/modules/${Code}`)
  }

  handleRightClick(e, Code) {
    e.preventDefault()
    const rect = e.target.getBoundingClientRect()
    this.setState({
      showPopup: true,
      popupPosition: { x: rect.left + window.scrollX, y: rect.top + window.scrollY },
      selectedCode: Code,
    })
  }

  hidePopup() {
    this.setState({ showPopup: false, selectedCode: null })
  }

  openInNewTab() {
    const { selectedCode } = this.state
    if (selectedCode) {
      window.open(window.location.origin + `/modules/${selectedCode}`, '_blank', 'noopener,noreferrer')
      this.hidePopup()
    }
  }

  getModeType(mode) {
    switch (mode) {
      case 0:  return "BLE"
      case 1:  return "PIN"
      case 2:  return "RFID"
      default: return "BLE"
    }
  }

  render() {
    const { prefix, modules } = this.props
    const { showPopup, popupPosition } = this.state
    const filtered = modules.filter(m => m.Code.substring(0, 5) === prefix)

    return (
      <div onClick={this.hidePopup}>
        <p style={{ fontSize: 12, color: '#666', marginBottom: 10 }}>
          {filtered.length} módulo{filtered.length !== 1 ? 's' : ''} — haz clic para ver detalle, clic derecho para abrir en nueva pestaña
        </p>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
          gap: '8px',
          pointerEvents: showPopup ? 'none' : 'auto',
        }}>
          {filtered.map(module => {
            const hardLabel = module.HardType ? (module.HardType == 2 ? 'Pincho' : 'Slide') : 'Pincho'
            return (
              <div
                key={module.Code}
                onClick={e => { e.stopPropagation(); this.goTo(module.Code) }}
                onContextMenu={e => { e.stopPropagation(); this.handleRightClick(e, module.Code) }}
                style={{
                  border: '1px solid #dde3ec',
                  borderRadius: 8,
                  padding: '8px 10px',
                  cursor: 'pointer',
                  background: '#fff',
                  transition: 'box-shadow 0.15s, transform 0.12s',
                  fontSize: 11,
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.boxShadow = '0 3px 10px rgba(2,32,64,0.15)'
                  e.currentTarget.style.transform = 'translateY(-1px)'
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.boxShadow = 'none'
                  e.currentTarget.style.transform = 'none'
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 12, color: '#022040', marginBottom: 5, wordBreak: 'break-all' }}>
                  {module.Code}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
                  {[
                    this.getModeType(module.ModeType),
                    module.Mode || '—',
                    module.Wide ? `W${module.Wide}` : '—',
                    `ESP${module.Espressif || 0}`,
                    module.Gender || '—',
                    hardLabel,
                  ].map((tag, i) => {
                    const missing = tag === '—'
                    const isPincho = tag === 'Pincho'
                    const isSlide  = tag === 'Slide'
                    const bg    = missing ? '#fde8e8' : isPincho ? '#e8f4fd' : isSlide ? '#fef3e2' : '#eef2f8'
                    const color = missing ? '#c0392b' : isPincho ? '#1a6fa8' : isSlide ? '#b85c00' : '#3a5a80'
                    return (
                      <span key={i} style={{
                        background: bg,
                        color,
                        borderRadius: 4,
                        padding: '1px 5px',
                        fontSize: 10,
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                      }}>{tag}</span>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>

        {showPopup && (
          <div
            onClick={e => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: popupPosition.y,
              left: popupPosition.x,
              zIndex: 1000,
              display: 'flex',
              flexDirection: 'column',
              gap: 6,
            }}
          >
            <button
              onClick={e => { e.stopPropagation(); e.preventDefault(); this.openInNewTab() }}
              style={{
                background: 'linear-gradient(135deg, #022040, #0a4080)',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 16px',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <i className="fas fa-external-link-alt"></i>
              Abrir en pestaña nueva
            </button>
            <button
              onClick={this.hidePopup}
              style={{
                background: '#f1f5f9',
                color: '#334155',
                border: '1px solid #dde3ec',
                borderRadius: 8,
                padding: '6px 16px',
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Cancelar
            </button>
          </div>
        )}
      </div>
    )
  }
}

export default ModuleList
